import Main from '@/views/main/main.vue';
import dict from './dict';
import config from './config';

export default {
    path: '/sys_manage',
    name: 'sys_manage',
    meta: {icon: 'md-options'},
    component: Main,
    children: [...dict, ...config],
};
